/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * CustomerPolicy.tsx
 */

import Policy from "../tools/provider/Policy";

export default class ManagerPolicy implements Policy {
    /**
     * canSeeUsers
     * @returns {boolean}
     */
    public canSeeUsers(): boolean {
        return true;
    }
}